/* yn-chrome.js (package A): announcement rotation, header (optional hide on scroll, desktop drop-down, back button),
   shop-by-age chips, menu and search sheets (live search), cart labels, bottom bar, footer (buddy peek, newsletter),
   floating app widgets.
   Plain JavaScript, no libraries. Safe on pages where none of these elements exist. Talks to yn-core.js only
   through window.Yuno (size, sheet events) and CustomEvents on document; uses window.YK (yn-kit.js) for the buddy when it is there. */
(function () {
  'use strict';
  if (window.__ynChrome) return;
  window.__ynChrome = true;

  /* every text a visitor can see or hear goes through T: English in sentence case, Arabic on /ar (snippets/yn-i18n.liquid) */
  var T = (window.Yuno && window.Yuno.T) || function (s, p) { if (p) for (var k in p) s = s.split('[' + k + ']').join(p[k]); return s; };

  var doc = document;
  var html = doc.documentElement;
  var phoneMQ = window.matchMedia ? window.matchMedia('(max-width: 989px)') : { matches: false };
  var reducedMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function reduced() { return html.classList.contains('yn-reduced') || reducedMQ.matches; }
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function Y() { return window.Yuno || null; }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function kitBuddy() { return window.YK && window.YK.buddy ? window.YK.buddy : null; }

  if (Y() && Y().config && Y().config.market === 'EG') html.classList.add('yn-mk-eg');

  /* ------------------------------------------------------------------ small motion helpers */
  function shake(el) {
    if (!el || !el.animate || reduced()) return;
    el.animate([
      { transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' },
      { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }
    ], { duration: 260, easing: 'ease-in-out' });
  }

  /* the footer buddy hops when someone joins the club (the kit's hop when it is loaded) */
  function hop(host) {
    var b = host && (host.querySelector('[data-yn-buddy]') || host.querySelector('svg'));
    if (!b || reduced()) return;
    var kb = kitBuddy();
    if (kb && typeof kb.hop === 'function') { try { kb.hop(b); return; } catch (e) {} }
    if (!b.animate) return;
    b.style.transformOrigin = '50% 100%';
    b.animate([
      { transform: 'translateY(0) scale(1,1)' },
      { transform: 'translateY(0) scale(1.08,.9)', offset: 0.18 },
      { transform: 'translateY(-18px) scale(.95,1.06)', offset: 0.5 },
      { transform: 'translateY(0) scale(1.06,.94)', offset: 0.82 },
      { transform: 'translateY(0) scale(1,1)' }
    ], { duration: 620, easing: 'ease-out' });
  }

  /* a buddy rises from behind an edge, tilted (the CSS in yn-chrome.css does the move) */
  function peek(el, delay) {
    if (!el) return;
    el.classList.remove('is-in');
    el.style.setProperty('--yn-peek-delay', (delay || 0) + 'ms');
    void el.offsetWidth;
    el.classList.add('is-in');
  }

  /* ------------------------------------------------------------------ remembered size (shop by age) */
  function getSize() {
    var y = Y();
    try { if (y && y.size && typeof y.size.get === 'function') return y.size.get() || null; } catch (e) {}
    try { return localStorage.getItem('yuno-age') || null; } catch (e2) { return null; }
  }
  function setSize(v) {
    var y = Y();
    if (y && y.size && typeof y.size.set === 'function') { y.size.set(v); return; }
    try { if (v) localStorage.setItem('yuno-age', v); else localStorage.removeItem('yuno-age'); } catch (e) {}
  }
  function syncAges() {
    var cur = getSize();
    $$('[data-yn-nav-age]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-yn-nav-age') === cur ? 'true' : 'false');
    });
  }
  doc.addEventListener('yuno:size', syncAges);

  /* a chip: tap an unpressed one to remember the size and go to all products; tap the pressed one to clear it */
  doc.addEventListener('click', function (e) {
    var chip = closest(e.target, '[data-yn-nav-age]');
    if (!chip) return;
    var label = chip.getAttribute('data-yn-nav-age');
    if (chip.getAttribute('aria-pressed') === 'true') { setSize(null); syncAges(); return; }
    setSize(label);
    syncAges();
    var base = chip.getAttribute('data-url') || '/collections/all';
    window.location.assign(base + (base.indexOf('?') > -1 ? '&' : '?') + 'size=' + encodeURIComponent(label));
  });

  /* ------------------------------------------------------------------ announcement line */
  function initAnn(el) {
    if (el.__ynAnn) return;
    el.__ynAnn = true;
    var msgs = $$('[data-yn-ann-msg]', el);
    if (msgs.length < 2) return;
    var secs = parseInt(el.getAttribute('data-interval'), 10) || 4;
    var idx = 0;
    var paused = false;
    var onScreen = true;
    var timer = 0;

    function setLink(msg, on) {
      var a = $('a', msg);
      if (!a) return;
      if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1');
    }
    function show(n) {
      var next = msgs[n % msgs.length];
      var prev = msgs[idx];
      if (prev === next) return;
      idx = n % msgs.length;
      prev.classList.remove('is-on');
      prev.classList.add('is-leave');
      prev.setAttribute('aria-hidden', 'true');
      setLink(prev, false);
      next.classList.remove('is-leave');
      next.classList.add('is-on');
      next.removeAttribute('aria-hidden');
      setLink(next, true);
      setTimeout(function () { prev.classList.remove('is-leave'); }, 300);
    }
    function tick() {
      clearTimeout(timer);
      if (reduced()) return;
      timer = setTimeout(function () {
        if (!paused && onScreen && !doc.hidden && !reduced()) show(idx + 1);
        tick();
      }, secs * 1000);
    }
    function pause() { paused = true; }
    function resume() { paused = false; }

    el.addEventListener('pointerdown', pause);
    el.addEventListener('pointerup', resume);
    el.addEventListener('pointercancel', resume);
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('focusin', pause);
    el.addEventListener('focusout', resume);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }).observe(el);
    }
    tick();
  }

  /* ------------------------------------------------------------------ header */
  var HDR = null;
  var lastY = window.pageYOffset || 0;
  var ticking = false;

  function megaSet(btn, open) {
    var hdr = closest(btn, '.yn-hdr');
    var mega = hdr && $('[data-yn-mega]', hdr);
    if (!mega) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    mega.classList.toggle('is-open', !!open);
  }
  function closeMegas(returnFocus) {
    $$('[data-yn-mega-toggle][aria-expanded="true"]').forEach(function (b) {
      megaSet(b, false);
      if (returnFocus) { try { b.focus(); } catch (e) {} }
    });
  }

  function setHidden(hdr, v) {
    if (!hdr || hdr.__ynHidden === v) return;
    hdr.__ynHidden = v;
    hdr.classList.toggle('is-hidden', v);
    if (v) closeMegas(false);
  }

  /* optional (header setting): on phones the header slides away on scroll down and returns on scroll up */
  function onScroll() {
    ticking = false;
    var hdr = HDR;
    if (!hdr) return;
    var y = window.pageYOffset || html.scrollTop || 0;
    var dy = y - lastY;
    lastY = y;
    var on = hdr.getAttribute('data-hide') === 'true' && phoneMQ.matches && !hdr.classList.contains('is-design');
    if (!on || html.classList.contains('yn-sheet-open')) { setHidden(hdr, false); return; }
    if (dy > 4 && y > 140) setHidden(hdr, true);
    else if (dy < -2 || y <= 0) setHidden(hdr, false);
  }
  window.addEventListener('scroll', function () {
    if (!ticking && HDR && HDR.getAttribute('data-hide') === 'true') { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });
  if (phoneMQ.addEventListener) phoneMQ.addEventListener('change', onScroll);

  function initHeader(hdr) {
    if (hdr.__ynHdr) return;
    hdr.__ynHdr = true;
    HDR = hdr;
    var wrap = closest(hdr, '.shopify-section');
    if (wrap && !hdr.classList.contains('is-design')) wrap.classList.add('yn-hdr-wrap');
    hdr.addEventListener('focusin', function () { setHidden(hdr, false); });
    hdr.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (to && !hdr.contains(to)) closeMegas(false);
    });
  }

  doc.addEventListener('click', function (e) {
    var t = closest(e.target, '[data-yn-mega-toggle]');
    if (t) { megaSet(t, t.getAttribute('aria-expanded') !== 'true'); return; }
    if ($('[data-yn-mega-toggle][aria-expanded="true"]') && !closest(e.target, '[data-yn-mega]')) closeMegas(false);
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && $('[data-yn-mega-toggle][aria-expanded="true"]')) closeMegas(true);
  });

  /* the back button: the browser's back when we came from this shop, otherwise the link's own fallback */
  doc.addEventListener('click', function (e) {
    var a = closest(e.target, '[data-yn-ch-back]');
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var same = false;
    try { same = !!doc.referrer && new URL(doc.referrer).origin === window.location.origin; } catch (err) {}
    if (same && window.history.length > 1) { e.preventDefault(); window.history.back(); }
  });

  /* ------------------------------------------------------------------ cart: labels and status (yn-core.js keeps the count itself) */
  var lastCount = null;
  function currentBadgeCount() {
    var b = $('[data-yn-cart-count]');
    var n = b ? parseInt(b.textContent, 10) : 0;
    return isNaN(n) ? 0 : n;
  }
  function onCart(e) {
    var c = (e && e.detail && e.detail.cart) || (Y() && Y().cart && Y().cart.state) || null;
    if (!c || typeof c.item_count !== 'number') return;
    var n = c.item_count;
    if (lastCount === null) lastCount = currentBadgeCount();
    var label = T('Cart, items: [n]', { n: n });
    $$('[data-yn-cart-open]').forEach(function (b) {
      if (closest(b, '.yn-hdr, .yn-bar')) b.setAttribute('aria-label', label);
    });
    if (n !== lastCount) {
      var text = n === 0 ? T('Your cart is empty') : T('Items in your cart: [n]', { n: n });
      $$('[data-yn-chrome-status]').forEach(function (s) { s.textContent = text; });
    }
    lastCount = n;
  }
  doc.addEventListener('yuno:cart', onCart);

  /* ------------------------------------------------------------------ bottom bar (filter tab on collection pages) */
  function initBar(bar) {
    if (bar.__ynBar) return;
    bar.__ynBar = true;
    var f = $('[data-yn-bar-filter]', bar);
    if (!f) return;
    function check() { f.hidden = !doc.getElementById('yn-sheet-filters'); }
    check();
    window.addEventListener('load', check);
    doc.addEventListener('yuno:ready', check);
  }
  /* package D already writes the filter count into every [data-yn-filter-count] and toggles .is-on;
     this event is a fallback for anyone who wants to set it without touching the collection script */
  doc.addEventListener('yuno:filters', function (e) {
    var n = (e.detail && Number(e.detail.count)) || 0;
    $$('[data-yn-filter-count]').forEach(function (el) { el.textContent = n ? String(n) : ''; el.classList.toggle('is-on', n > 0); });
  });

  /* ------------------------------------------------------------------ menu and search sheets: open */
  doc.addEventListener('yuno:sheet:open', function (e) {
    var id = e.detail && e.detail.id;
    closeMegas(false);
    if (id === 'yn-sheet-menu') {
      var menu = doc.getElementById(id);
      if (!menu) return;
      syncAges();
      peek($('[data-yn-ch-peek]', menu), 380);
    }
  });

  /* ------------------------------------------------------------------ search: live results */
  function initSearch(sheet) {
    if (sheet.__ynSearch) return;
    sheet.__ynSearch = true;
    var form = $('[data-yn-search-form]', sheet);
    var input = $('[data-yn-search-input]', sheet);
    if (!form || !input) return;

    var states = {};
    $$('[data-yn-srch-state]', sheet).forEach(function (n) { states[n.getAttribute('data-yn-srch-state')] = n; });
    var status = $('[data-yn-srch-status]', sheet);
    var url = sheet.getAttribute('data-predictive-url') || '/search/suggest';
    var searchUrl = sheet.getAttribute('data-search-url') || '/search';
    /* Shopify's live search does not know every language (Arabic answers HTTP 417 "unsupported buyer locale"). Then it is asked
       at the same path without the language prefix (the shop's main language) and the result links get the prefix back. */
    var root = (Y() && Y().config && Y().config.routes && Y().config.routes.root) || '/';
    var prefix = root.length > 1 ? root.replace(/\/$/, '') : '';
    var mainUrl = (prefix && url.indexOf(prefix + '/') === 0) ? url.slice(prefix.length) : url;
    var noneTpl = sheet.getAttribute('data-none-title') || T('Nothing called “{q}” yet');
    var seeAll = sheet.getAttribute('data-see-all') || T('See all results');

    var cache = {};
    var seq = 0;
    var ctrl = null;
    var deb = 0;
    var slowT = 0;
    var lastQ = '';
    var current = 'idle';
    var eyesAnim = null;

    function say(text) { if (status) status.textContent = text; }

    function show(name) {
      current = name;
      Object.keys(states).forEach(function (k) { states[k].hidden = k !== name; });
      if (name !== 'loading' && states.loading) states.loading.classList.remove('is-slow');
      if (name !== 'results' && states.results) states.results.classList.remove('is-stale');
    }

    /* the buddy's eyes look side to side while a slow search runs (never a spinner) */
    function eyes(on) {
      var host = $('[data-yn-searching]', sheet);
      var b = host && (host.querySelector('[data-yn-buddy]') || host.querySelector('svg'));
      var kb = kitBuddy();
      if (kb && typeof kb.searching === 'function' && b) { try { kb.searching(b, !!on); } catch (e) {} return; }
      if (eyesAnim) { eyesAnim.forEach(function (a) { a.cancel(); }); eyesAnim = null; }
      if (!on || reduced() || !host) return;
      var pupils = $$('[data-b="pupilL"],[data-b="pupilR"]', host);
      if (!pupils.length) pupils = $$('ellipse', host);
      eyesAnim = pupils.filter(function (p) { return p.animate; }).map(function (p) {
        return p.animate([{ transform: 'translate(-22px,0)' }, { transform: 'translate(22px,0)' }],
          { duration: 700, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' });
      });
    }

    function setLoading() {
      var hasResults = current === 'results' && states.results && states.results.childNodes.length;
      if (hasResults) states.results.classList.add('is-stale');
      else show('loading');
      clearTimeout(slowT);
      slowT = setTimeout(function () {
        if (current === 'loading') { states.loading.classList.add('is-slow'); eyes(true); }
      }, 400);
    }

    function settle() {
      clearTimeout(slowT);
      eyes(false);
    }

    function render(q, data) {
      settle();
      if (data.count === 0) {
        var t = $('[data-yn-none-title]', states.none);
        if (t) t.textContent = noneTpl.replace('{q}', function () { return q; });
        show('none');
        say(T('Nothing found for [q]', { q: q }));
        return;
      }
      states.results.innerHTML = data.html;
      $$('.yn-srch__tag', states.results).forEach(function (el) { el.textContent = T('Sold out'); });
      if (prefix) {
        $$('a[href^="/"]', states.results).forEach(function (el) {
          var h = el.getAttribute('href');
          if (h.indexOf(prefix + '/') !== 0) el.setAttribute('href', prefix + h);
        });
      }
      if (data.more) {
        var a = doc.createElement('a');
        a.className = 'yn-srch__more';
        a.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
        a.textContent = seeAll;
        states.results.appendChild(a);
      }
      show('results');
      say(T('Results: [n]', { n: Math.min(data.count, 8) + (data.more ? '+' : '') }));
    }

    function fail() {
      settle();
      show('error');
      say(T('Search failed'));
    }

    function run(q) {
      var mine = ++seq;
      if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
      lastQ = q;
      if (cache[q]) { render(q, cache[q]); return; }
      setLoading();
      ctrl = window.AbortController ? new AbortController() : null;
      var sig = ctrl ? ctrl.signal : undefined;
      function ask(base) {
        var u = base + (base.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q) +
          '&section_id=yn-predictive-search&resources%5Btype%5D=product&resources%5Blimit%5D=10' +
          '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
        return fetch(u, { signal: sig, headers: { Accept: 'text/html' }, credentials: 'same-origin' });
      }
      ask(url)
        .then(function (r) {
          if (r.status === 417 && url !== mainUrl) { url = mainUrl; return ask(url); }
          return r;
        })
        .then(function (r) { if (!r.ok) throw new Error('search ' + r.status); return r.text(); })
        .then(function (txt) {
          if (mine !== seq) return;
          var d = new DOMParser().parseFromString(txt, 'text/html');
          var frag = d.querySelector('[data-yn-predictive]');
          if (!frag) throw new Error('no results fragment');
          var data = {
            count: parseInt(frag.getAttribute('data-count'), 10) || 0,
            more: frag.getAttribute('data-more') === 'true',
            html: frag.innerHTML
          };
          cache[q] = data;
          render(q, data);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (mine !== seq) return;
          fail();
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(deb);
      if (!q) {
        seq++;
        if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
        settle();
        show('idle');
        say('');
        return;
      }
      if (cache[q]) { run(q); return; }
      setLoading();
      deb = setTimeout(function () { run(q); }, 250);
    });

    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) e.preventDefault();
    });

    sheet.addEventListener('click', function (e) {
      var chip = closest(e.target, '[data-yn-srch-popular]');
      if (chip) {
        var q = chip.getAttribute('data-yn-srch-popular');
        input.value = q;
        clearTimeout(deb);
        run(q);
        if (!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)) input.focus();
        return;
      }
      if (closest(e.target, '[data-yn-srch-retry]') && lastQ) run(lastQ);
    });

    /* arrow keys move between the field and the results */
    sheet.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      if (!states.results || states.results.hidden) return;
      var items = $$('[data-yn-srch-result], .yn-srch__more', states.results);
      if (!items.length) return;
      var t = e.target;
      var i = items.indexOf(t);
      if (t === input && e.key === 'ArrowDown') { e.preventDefault(); items[0].focus(); }
      else if (i > -1) {
        e.preventDefault();
        if (e.key === 'ArrowDown') (items[i + 1] || items[i]).focus();
        else (i === 0 ? input : items[i - 1]).focus();
      }
    });
  }

  /* ------------------------------------------------------------------ footer: buddy peek, newsletter */
  function initFooter(ft) {
    if (ft.__ynFooter) return;
    ft.__ynFooter = true;
    var buddies = $$('[data-yn-ch-peek]', ft);
    if (!buddies.length) return;
    function go() { buddies.forEach(function (b) { peek(b, 200); }); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { io.disconnect(); go(); }
      }, { threshold: 0.05 });
      io.observe(ft);
    } else {
      go();
    }
  }

  function initNl(form) {
    if (form.__ynNl) return;
    form.__ynNl = true;
    var wrap = $('[data-yn-nl-wrap]', form);
    var input = $('[data-yn-nl-email]', form);
    var msg = $('[data-yn-nl-msg]', form);
    var fields = $('[data-yn-nl-fields]', form);
    var done = $('[data-yn-nl-done]', form);
    var box = $('[data-yn-nl-box]', form);
    if (!wrap || !input || !msg || !fields || !done) return;
    var busy = false;
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function clearError() {
      wrap.classList.remove('is-error');
      input.removeAttribute('aria-invalid');
      msg.textContent = '';
    }
    function showError(text) {
      wrap.classList.remove('is-loading');
      wrap.classList.add('is-error');
      input.setAttribute('aria-invalid', 'true');
      msg.textContent = text;
      shake(box);
    }
    function success() {
      wrap.classList.remove('is-loading', 'is-error');
      wrap.classList.add('is-done');
      fields.hidden = true;
      done.hidden = false;
      try { done.focus({ preventScroll: true }); } catch (e) {}
      hop($('[data-yn-footer-buddy]'));
    }

    input.addEventListener('input', function () { if (wrap.classList.contains('is-error')) clearError(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (!re.test(input.value.trim())) {
        showError(form.getAttribute('data-err-invalid') || T('That email looks a little off. Try again?'));
        input.focus();
        return;
      }
      clearError();
      busy = true;
      wrap.classList.add('is-loading');
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) {
          var u = r.url || '';
          if (u.indexOf('/challenge') > -1) { busy = false; form.submit(); return; }
          if (r.ok && u.indexOf('customer_posted=true') > -1) { success(); return; }
          throw new Error('newsletter');
        })
        .catch(function () {
          showError(form.getAttribute('data-err-fail') || T('That didn’t go through. Please try again in a moment.'));
        })
        .then(function () { busy = false; });
    });
  }

  /* ------------------------------------------------------------------ floating app widgets (WhatsApp, currency) */
  var FLOAT_SEL = '#wn-chat-button, .wn-chat-button-wrapper, #whatsapp-chat-widget, [class*="whatsapp-button"], [id*="whapi"], [class*="whapi"]';
  var CUR_SEL = '.buckscc-select-styled, .bucks-currency-converter, [class*="buckscc"]';
  var floatTimer = 0;
  var shadowHosts = [];

  /* one of the WhatsApp apps keeps its button in a shadow root (<gty-whatsapp-chat-button>): the page's CSS cannot
     reach it, so the same rules are written into that shadow root, driven by attributes on its host */
  var SHADOW_CSS =
    '.yn-float{translate:0 calc(var(--yn-bottom,0px) * -1)!important;transform-origin:50% 100%!important;' +
    'transition:translate 260ms cubic-bezier(.2,.8,.2,1),scale 260ms cubic-bezier(.2,.8,.2,1),opacity 180ms linear!important}' +
    ':host([data-yn-down]) .yn-float{scale:.6!important}' +
    ':host([data-yn-hide]) .yn-float{opacity:0!important;visibility:hidden!important;pointer-events:none!important}' +
    ':host([data-yn-reduced]) .yn-float{transition:opacity 180ms linear!important}' +
    ':host([data-yn-reduced][data-yn-down]) .yn-float{scale:1!important}';

  function syncShadow() {
    var cl = html.classList;
    var down = cl.contains('yn-scrolling-down');
    var hide = cl.contains('yn-sheet-open') || cl.contains('yn-toast-open');
    var red = reduced();
    shadowHosts.forEach(function (h) {
      if (down) h.setAttribute('data-yn-down', ''); else h.removeAttribute('data-yn-down');
      if (hide) h.setAttribute('data-yn-hide', ''); else h.removeAttribute('data-yn-hide');
      if (red) h.setAttribute('data-yn-reduced', ''); else h.removeAttribute('data-yn-reduced');
    });
  }
  if ('MutationObserver' in window) {
    new MutationObserver(syncShadow).observe(html, { attributes: true, attributeFilter: ['class'] });
  }

  function adoptShadow(host) {
    if (host.__ynShadow || !host.shadowRoot) return;
    var fixed = $$('*', host.shadowRoot).filter(function (e) { return window.getComputedStyle(e).position === 'fixed'; });
    if (!fixed.length) return;
    host.__ynShadow = true;
    var st = doc.createElement('style');
    st.textContent = SHADOW_CSS;
    host.shadowRoot.appendChild(st);
    fixed.forEach(function (e) { e.classList.add('yn-float'); });
    shadowHosts.push(host);
    syncShadow();
  }

  /* the brief asks for exactly one WhatsApp button: while several apps are on, the first of these stays
     (Whapi, then the shadow-root app, then any other) and the rest are hidden */
  function dedupeWhatsApp(lightFloats) {
    var cands = [];
    lightFloats.forEach(function (el) {
      if (!el.matches(CUR_SEL)) cands.push({ el: el, rank: el.matches('#wn-chat-button, .wn-chat-button-wrapper') ? 1 : 3 });
    });
    shadowHosts.forEach(function (h) { cands.push({ el: h, rank: 2 }); });
    cands.sort(function (a, b) { return a.rank - b.rank; });
    cands.forEach(function (c, i) {
      if (i === 0) c.el.removeAttribute('data-yn-wa-dup'); else c.el.setAttribute('data-yn-wa-dup', '');
    });
  }

  function tagFloats() {
    var found = [];
    $$(FLOAT_SEL + ', ' + CUR_SEL).forEach(function (el) {
      if (closest(el, '.yn-hdr, .yn-bar, .yn-ftr, .yn-ann, .yn-sheet')) return;
      var cs = window.getComputedStyle(el);
      if (cs && cs.position === 'fixed') found.push(el);
    });
    var outer = [];
    found.forEach(function (el) {
      for (var p = el.parentElement; p; p = p.parentElement) { if (found.indexOf(p) > -1) return; }
      el.classList.add('yn-float');
      if (el.matches(CUR_SEL)) el.classList.add('yn-float--cur');
      outer.push(el);
    });
    $$('*').forEach(function (el) { if (el.localName.indexOf('-') > 0 && /whatsapp/.test(el.localName) && el.shadowRoot) adoptShadow(el); });
    dedupeWhatsApp(outer);
  }
  function scheduleFloats() {
    clearTimeout(floatTimer);
    floatTimer = setTimeout(tagFloats, 400);
  }
  if ('MutationObserver' in window && doc.body) {
    new MutationObserver(scheduleFloats).observe(doc.body, { childList: true, subtree: true });
  }
  window.addEventListener('load', function () { scheduleFloats(); setTimeout(tagFloats, 2500); setTimeout(tagFloats, 6000); });

  /* ------------------------------------------------------------------ init */
  function init(root) {
    root = root || doc;
    $$('[data-yn-ann]', root).forEach(initAnn);
    $$('[data-yn-header]', root).forEach(initHeader);
    $$('[data-yn-sheet-search]', root).forEach(initSearch);
    $$('[data-yn-footer]', root).forEach(initFooter);
    $$('[data-yn-nl]', root).forEach(initNl);
    $$('[data-yn-bar]', root).forEach(initBar);
    if (lastCount === null) lastCount = currentBadgeCount();
    syncAges();
    scheduleFloats();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);

  /* theme editor: sections re-render in place */
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();